module.exports = __webpack_public_path__ + "img/Bethany_Baobei.0b07953d.jpg";